var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":"centreLeft2Chart","height":"4.625rem","width":"4.125rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }